import React from "react";
const AgricultureSvg = (props) => (
  <svg
    height="100%"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    className="animated"
    viewBox="0 0 500 500"
    {...props}
  >
    <g
      className="animable"
      style={{
        transformOrigin: "249.297px 263.414px",
      }}
    >
      <path
        d="M166.19 77.92S90.42 116.52 52.63 176s-34.8 136 11.12 192.8 133.69 49.34 207.18 85.32 154.57 28.57 189.32-47.66-17.65-104.72-26.65-192.94-88.53-217.4-267.41-135.6Z"
        className="animable"
        style={{
          fill: "#1dd21d",
          transformOrigin: "249.297px 263.414px",
        }}
      />
      <path
        d="M166.19 77.92S90.42 116.52 52.63 176s-34.8 136 11.12 192.8 133.69 49.34 207.18 85.32 154.57 28.57 189.32-47.66-17.65-104.72-26.65-192.94-88.53-217.4-267.41-135.6Z"
        className="animable"
        style={{
          fill: "#fff",
          opacity: 0.8,
          transformOrigin: "249.297px 263.414px",
        }}
      />
    </g>
    <g
      className="animable"
      style={{
        transformOrigin: "341.535px 78.9295px",
      }}
    >
      <path
        d="M394.43 76c-4.68-2.56-6.81-.43-8.52-2.56s4.69-7.67-8.09-13.2c0 0-.85-11.93-18.32-12.36S346.72 59.84 342 62.82s-6-1.7-10.65 1.28-2.56 9-6.39 9.8-8.95-3.84-13.63-.85-4.69 5.53-6.82 5.53-6.39-1.7-8.94 0-5.54 3.84-5.54 3.84h107.81s1.28-3.84-3.41-6.42Z"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "344.015px 65.1445px",
        }}
      />
      <path
        d="M330.68 74.28a15.7 15.7 0 0 1-1.9.9"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "329.73px 74.73px",
        }}
      />
      <path
        d="M353.74 54.38a7.27 7.27 0 0 0-4.16 5.2c-.78 3.9-2.6 6.5-4.68 6.76s-9.88-.52-11.18 2.34a11.36 11.36 0 0 0-.73 2.61"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "343.365px 62.835px",
        }}
      />
      <path
        d="M339.79 106.65c-2.46-1.34-3.57-.22-4.47-1.34s2.46-4-4.24-6.92c0 0-.45-6.26-9.6-6.48s-6.7 6.25-9.16 7.82-3.13-.9-5.58.67-1.34 4.69-3.35 5.13-4.7-2-7.15-.44-2.46 2.9-3.58 2.9-3.35-.89-4.69 0-2.9 2-2.9 2h56.51s.67-1.99-1.79-3.34Z"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "313.367px 100.947px",
        }}
      />
      <path
        d="M306.36 105.73a6.63 6.63 0 0 1-1 .47"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "305.86px 105.965px",
        }}
      />
      <path
        d="M318.45 95.3a3.81 3.81 0 0 0-2.18 2.7c-.41 2-1.36 3.41-2.45 3.55s-5.18-.27-5.86 1.23a6 6 0 0 0-.39 1.36"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "313.01px 99.72px",
        }}
      />
    </g>
    <g
      className="animable"
      style={{
        transformOrigin: "256.627px 236.294px",
      }}
    >
      <path
        d="M56.58 201.5s45 4.45 67.77 32.33c0 0 24.08-32.3 67.34-31.63a87.41 87.41 0 1 0-135.12-.62Z"
        className="animable"
        style={{
          fill: "#1dd21d",
          transformOrigin: "124.384px 146.424px",
        }}
      />
      <path
        d="M56.58 201.5s45 4.45 67.77 32.33c0 0 24.08-32.3 67.34-31.63a87.41 87.41 0 1 0-135.12-.62Z"
        className="animable"
        style={{
          fill: "#fff",
          opacity: 0.5,
          transformOrigin: "124.384px 146.424px",
        }}
      />
      <path
        d="M122.86 65.16 121.34 409h7.6l-6.08-343.84z"
        className="animable"
        style={{
          fill: "#263238",
          transformOrigin: "125.14px 237.08px",
        }}
      />
      <path
        d="M125.14 225.33s15.18-27.32 42.51-35.67c0 0-28.85 6.83-43.27 30.36Z"
        className="animable"
        style={{
          fill: "#263238",
          transformOrigin: "146.015px 207.495px",
        }}
      />
      <path
        d="M125.14 147.91s15.18-27.33 42.51-35.68c0 0-28.85 6.83-43.27 30.36Z"
        className="animable"
        style={{
          fill: "#263238",
          transformOrigin: "146.015px 130.07px",
        }}
      />
      <path
        d="M125.14 186.62s15.18-27.33 42.51-35.68c0 0-28.85 6.83-43.27 30.37Z"
        className="animable"
        style={{
          fill: "#263238",
          transformOrigin: "146.015px 168.78px",
        }}
      />
      <path
        d="M122.89 167.64s-14.65-27.33-41-35.68c0 0 27.84 6.84 41.75 30.37Z"
        className="animable"
        style={{
          fill: "#263238",
          transformOrigin: "102.765px 149.8px",
        }}
      />
      <path
        d="M122.89 205.6s-14.65-27.33-41-35.68c0 0 27.84 6.83 41.75 30.36Z"
        className="animable"
        style={{
          fill: "#263238",
          transformOrigin: "102.765px 187.76px",
        }}
      />
      <path
        d="M345.8 230.93s38.6 3.82 58.16 27.75c0 0 20.66-27.72 57.78-27.15a75 75 0 1 0-115.95-.53Z"
        className="animable"
        style={{
          fill: "#1dd21d",
          transformOrigin: "403.982px 183.683px",
        }}
      />
      <path
        d="M345.8 230.93s38.6 3.82 58.16 27.75c0 0 20.66-27.72 57.78-27.15a75 75 0 1 0-115.95-.53Z"
        className="animable"
        style={{
          fill: "#fff",
          opacity: 0.5,
          transformOrigin: "403.982px 183.683px",
        }}
      />
      <path
        d="M402.68 113.93 401.38 409h6.51l-5.21-295.07z"
        className="animable"
        style={{
          fill: "#263238",
          transformOrigin: "404.635px 261.465px",
        }}
      />
      <path
        d="M404.63 251.38s13-23.45 36.48-30.61c0 0-24.75 5.86-37.13 26Z"
        className="animable"
        style={{
          fill: "#263238",
          transformOrigin: "422.545px 236.075px",
        }}
      />
      <path
        d="M404.63 184.94s13-23.45 36.48-30.62c0 0-24.75 5.86-37.13 26.06Z"
        className="animable"
        style={{
          fill: "#263238",
          transformOrigin: "422.545px 169.63px",
        }}
      />
      <path
        d="M404.63 218.16s13-23.45 36.48-30.62c0 0-24.75 5.87-37.13 26.06Z"
        className="animable"
        style={{
          fill: "#263238",
          transformOrigin: "422.545px 202.85px",
        }}
      />
      <path
        d="M402.7 201.88s-12.57-23.46-35.2-30.62c0 0 23.89 5.86 35.83 26.06Z"
        className="animable"
        style={{
          fill: "#263238",
          transformOrigin: "385.415px 186.57px",
        }}
      />
      <path
        d="M402.7 234.45s-12.57-23.45-35.2-30.62c0 0 23.89 5.86 35.83 26.06Z"
        className="animable"
        style={{
          fill: "#263238",
          transformOrigin: "385.415px 219.14px",
        }}
      />
      <path
        d="M255.64 410.23c.14-3.13-.28-9.06-3.68-18-5.33-14-14.66 14-14.66 14s0-3.33-10-14-18.67 8-18.67 8 4.67-44.66-6.67-41.33-10 41.33-10 41.33-8-28-18.66-28-13.34 20-13.34 20-2.66-35.33-13.33-36S124 385.57 124 385.57s3.34-40-7.33-42S102 358.23 102 358.23s-9.33-55.33-27.33-48.66-2.67 68-2.67 68-18-42.67-32.7-32.67c-13.3 9.1 3.63 56.74 6.83 65.33Z"
        className="animable"
        style={{
          fill: "#1dd21d",
          transformOrigin: "144.967px 359.621px",
        }}
      />
      <path
        d="M40.63 411.57s-8-25.34-4-29.34S58 395.57 58 395.57s-12.66-42.67 7.34-48 23.29 41.33 23.29 41.33 14.67-21.33 18-13.33A44.37 44.37 0 0 1 110 390.9s7.34-58 24-55.33 1.34 60 1.34 60 9.33-20 20-18S170 392.23 170 392.23s4.67-11.33 8-11.33 7.34 20 7.34 20 4-30.67 11.33-29.33 22.63 27.33 22.63 27.33-2.67-14.67 5.33-15.33 12.67 22.66 12.67 22.66 10.66-22 17.33-18 3.37 25.34 3.37 25.34"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "147.163px 374.525px",
        }}
      />
      <path
        d="m77.3 411.57-6.67-30"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "73.965px 396.57px",
        }}
      />
      <path
        d="m117.96 410.23 3.34-18.66"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "119.63px 400.9px",
        }}
      />
      <path
        d="m203.96 411.57-6-16.67"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "200.96px 403.235px",
        }}
      />
      <path
        d="m150.63 410.9 7.33-13.33"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "154.295px 404.235px",
        }}
      />
      <path
        d="m75.3 398.9 5.33-10.67"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "77.965px 393.565px",
        }}
      />
      <path
        d="m117.96 404.23-4.66-9.33"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "115.63px 399.565px",
        }}
      />
      <path
        d="m153.96 403.57-3.33-6"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "152.295px 400.57px",
        }}
      />
      <path
        d="m201.3 402.9 2-6.67"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "202.3px 399.565px",
        }}
      />
      <path
        d="M460.22 410.23c.14-3.13-.28-9.06-3.68-18-5.33-14-14.66 14-14.66 14s0-3.33-10-14-18.67 8-18.67 8 4.67-44.66-6.67-41.33-10 41.33-10 41.33-8-28-18.66-28-13.34 20-13.34 20-2.66-35.33-13.33-36-22.67 29.34-22.67 29.34 3.34-40-7.33-42-14.67 14.66-14.67 14.66-9.33-55.33-27.33-48.66-2.67 68-2.67 68-18-42.67-32.66-32.67c-13.34 9.09 3.63 56.74 6.83 65.33Z"
        className="animable"
        style={{
          fill: "#1dd21d",
          transformOrigin: "349.539px 359.621px",
        }}
      />
      <path
        d="M245.21 411.57s-8-25.34-4-29.34 21.33 13.34 21.33 13.34-12.66-42.67 7.34-48 23.33 41.33 23.33 41.33 14.67-21.33 18-13.33a44.37 44.37 0 0 1 3.33 15.33s7.34-58 24-55.33 1.34 60 1.34 60 9.33-20 20-18 14.66 14.66 14.66 14.66 4.67-11.33 8-11.33 7.34 20 7.34 20 4-30.67 11.33-29.33 22.67 27.33 22.67 27.33-2.67-14.67 5.33-15.33 12.67 22.66 12.67 22.66 10.66-22 17.33-18 3.33 25.34 3.33 25.34"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "351.733px 374.525px",
        }}
      />
      <path
        d="m281.88 411.57-6.67-30"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "278.545px 396.57px",
        }}
      />
      <path
        d="m322.54 410.23 3.34-18.66"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "324.21px 400.9px",
        }}
      />
      <path
        d="m408.54 411.57-6-16.67"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "405.54px 403.235px",
        }}
      />
      <path
        d="m355.21 410.9 7.33-13.33"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "358.875px 404.235px",
        }}
      />
      <path
        d="m279.88 398.9 5.33-10.67"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "282.545px 393.565px",
        }}
      />
      <path
        d="m322.54 404.23-4.66-9.33"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "320.21px 399.565px",
        }}
      />
      <path
        d="m358.54 403.57-3.33-6"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "356.875px 400.57px",
        }}
      />
      <path
        d="m405.88 402.9 2-6.67"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "406.88px 399.565px",
        }}
      />
    </g>
    <g
      className="animable"
      style={{
        transformOrigin: "353.39px 288.314px",
      }}
    >
      <path
        d="M231.28 335.82h11.11v77.75h-11.11z"
        className="animable"
        style={{
          fill: "#ccc",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "236.835px 374.695px",
        }}
      />
      <path
        d="M240.8 335.82h11.11v77.75H240.8z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "246.355px 374.695px",
        }}
      />
      <path
        d="M350.28 335.82h11.11v77.75h-11.11z"
        className="animable"
        style={{
          fill: "#ccc",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "355.835px 374.695px",
        }}
      />
      <path
        d="M359.8 335.82h11.11v77.75H359.8z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "365.355px 374.695px",
        }}
      />
      <path
        d="M418.51 335.82h11.11v77.75h-11.11z"
        className="animable"
        style={{
          fill: "#ccc",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "424.065px 374.695px",
        }}
      />
      <path
        d="M428.03 335.82h11.11v77.75h-11.11z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "433.585px 374.695px",
        }}
      />
      <path
        d="M404.23 335.82h11.11v77.75h-11.11z"
        className="animable"
        style={{
          fill: "#ccc",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "409.785px 374.695px",
        }}
      />
      <path
        d="M413.75 335.82h11.11v77.75h-11.11z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "419.305px 374.695px",
        }}
      />
      <path
        d="M452.62 335.82h11.11v77.75h-11.11z"
        className="animable"
        style={{
          fill: "#ccc",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "458.175px 374.695px",
        }}
      />
      <path
        d="M462.14 335.82h11.11v77.75h-11.11z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "467.695px 374.695px",
        }}
      />
      <path
        d="M370.47 164.07a4.77 4.77 0 0 0-6 .1l-67.09 55.91v12.39l70.23-58.53 74.95 58.4v-12.06Z"
        className="animable"
        style={{
          fill: "#b2b2b2",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "369.97px 197.764px",
        }}
      />
      <path
        d="M438.95 340.24H301.23V222.92l66.31-55.09 71.41 55.09v117.32z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "370.09px 254.035px",
        }}
      />
      <path
        d="M375.67 340.24h45.22v-44.08l-45.22-30.94v75.02z"
        className="animable"
        style={{
          fill: "#ccc",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "398.28px 302.73px",
        }}
      />
      <path
        d="M368.56 340.24H230.84V222.92l66.31-55.09 71.41 55.09v117.32z"
        className="animable"
        style={{
          fill: "#ccc",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "299.7px 254.035px",
        }}
      />
      <path
        d="M258.7 199.37h76.69"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "297.045px 199.37px",
        }}
      />
      <path
        d="M230.49 227.14h207.15"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "334.065px 227.14px",
        }}
      />
      <path
        d="M230.49 254.9h207.79"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "334.385px 254.9px",
        }}
      />
      <path
        d="M230.49 282.67h145.18"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "303.08px 282.67px",
        }}
      />
      <path
        d="M230.49 310.44h145.67"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "303.325px 310.44px",
        }}
      />
      <path
        d="M297.82 166.83h70.39l73.08 56.28H370.9l-73.08-56.28z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "369.555px 194.97px",
        }}
      />
      <path
        d="M318.88 181.06h67.44"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "352.6px 181.06px",
        }}
      />
      <path
        d="M337.73 195.38h66.98"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "371.22px 195.38px",
        }}
      />
      <path
        d="M356.57 209.69h66.77"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "389.955px 209.69px",
        }}
      />
      <path
        d="m370.82 219.2-70.74-55.13a4.77 4.77 0 0 0-6 .1l-66.83 55.69v12.39l70-58.31 73.57 57.33Z"
        className="animable"
        style={{
          fill: "#b2b2b2",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "299.035px 197.654px",
        }}
      />
      <path
        d="m479.53 301.75-51.44-32.88v-17.14l51.44 32.88v17.14z"
        className="animable"
        style={{
          fill: "#b2b2b2",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "453.81px 276.74px",
        }}
      />
      <path
        d="M418.51 340.24h57.91v-44.08l-57.91-30.94v75.02z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "447.465px 302.73px",
        }}
      />
      <path
        d="M424.9 296.2h53.94l-47.64-30.98h-55.53l49.23 30.98z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "427.255px 280.71px",
        }}
      />
      <path
        d="m424.39 301.75-51.43-32.88v-17.14l51.43 32.88v17.14z"
        className="animable"
        style={{
          fill: "#b2b2b2",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "398.675px 276.74px",
        }}
      />
      <path
        d="M273.33 275.98h46.81v64.26h-46.81z"
        className="animable"
        style={{
          fill: "#263238",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "296.735px 308.11px",
        }}
      />
      <path
        d="M273.33 213.3h46.81v64.26h-46.81z"
        className="animable"
        style={{
          fill: "#ccc",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "296.735px 245.43px",
        }}
      />
      <path
        d="M273.33 222.2h46.81v8.9h-46.81z"
        className="animable"
        style={{
          fill: "#b2b2b2",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "296.735px 226.65px",
        }}
      />
      <path
        d="M273.28 340.24h47.6l-33.22 73.33h-47.6l33.22-73.33z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "280.47px 376.905px",
        }}
      />
      <path
        d="M268.45 350.89h47.6l-2.87 6.35h-47.6l2.87-6.35z"
        className="animable"
        style={{
          fill: "#ccc",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "290.815px 354.065px",
        }}
      />
      <path
        d="M258.75 372.31h47.6l-2.88 6.35h-47.6l2.88-6.35z"
        className="animable"
        style={{
          fill: "#ccc",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "281.11px 375.485px",
        }}
      />
      <path
        d="M249.04 393.73h47.6l-2.87 6.35h-47.6l2.87-6.35z"
        className="animable"
        style={{
          fill: "#ccc",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "271.405px 396.905px",
        }}
      />
    </g>
    <g
      className="animable"
      style={{
        transformOrigin: "197px 449px",
      }}
    >
      <ellipse
        cx={197}
        cy={449}
        className="animable"
        rx={155}
        ry={21}
        style={{
          fill: "#1dd21d",
          transformOrigin: "197px 449px",
        }}
      />
      <ellipse
        cx={197}
        cy={449}
        className="animable"
        rx={155}
        ry={21}
        style={{
          fill: "#fff",
          opacity: 0.5,
          transformOrigin: "197px 449px",
        }}
      />
    </g>
    <g
      className="animable"
      style={{
        transformOrigin: "183.551px 265.511px",
      }}
    >
      <path
        d="M254 267s10.8 4.37 19 5.14 20.82-5.14 22.88-15.94-4.89-31.1-7.2-35.47-16.2-35.22-23.91-41.9-20.31-10.55-22.88-11.57-.77 8.74-1.28 14.91-.52 37.53-.52 37.53l-1.8 41.13s9.49 3.58 15.71 6.17Z"
        className="animable"
        style={{
          fill: "#fff",
          transformOrigin: "267.273px 219.696px",
        }}
      />
      <g
        className="animable"
        style={{
          clipPath: "url(_.html#freepik--clip-path--inject-69&quot",
          transformOrigin: "266.292px 222.785px",
        }}
      >
        <path
          d="M290.55 225.19a28.12 28.12 0 0 0-3.87-.24c-1.63-4.27-3.5-8.72-5.48-13 .75-.64 1.51-1.25 2.28-1.85l-.91-1.85c-.76.58-1.51 1.18-2.26 1.8a142.28 142.28 0 0 0-9-16.44c.5-1.4 1-2.69 1.38-3.85-.45-.75-.89-1.49-1.33-2.2-.42 1.16-.91 2.5-1.44 4a30.08 30.08 0 0 0-4-4.8 49.49 49.49 0 0 0-5.36-4.23q.9-3.21 1.65-5.69c-.56-.4-1.14-.79-1.73-1.17-.5 1.63-1.06 3.54-1.67 5.69a75.85 75.85 0 0 0-17-8l-.59 1.91a75.7 75.7 0 0 1 17 8.15c-.78 2.9-1.62 6.15-2.43 9.66a37.51 37.51 0 0 0-11-3.68l-.27 2a36.37 36.37 0 0 1 10.83 3.6c-.86 3.82-1.67 7.91-2.38 12.14a88.09 88.09 0 0 0-7.77-5.69l-1.07 1.69a89.1 89.1 0 0 1 8.47 6.31c-.65 4.15-1.18 8.4-1.52 12.66a60.35 60.35 0 0 0-7.61-5l-.94 1.76a61.17 61.17 0 0 1 8.38 5.7c-.18 2.94-.28 5.88-.24 8.76h2c0-2.34 0-4.72.15-7.12a42.54 42.54 0 0 1 4.74 4.92c-.34 1.42-.63 2.77-.88 4l1.23.24c-2 2.85-3.23 4.79-3.42 5.09l1.69 1.06.77-1.18.06.05s.44-.39 1.15-1v.22a27.8 27.8 0 0 1 6.43 2.53l-2 .92c-17.89 8.13-22.44 9.26-22.48 9.27l.45 1.95c.18 0 4.64-1.12 22.85-9.4q1.69-.76 3.18-1.5a19.28 19.28 0 0 1 7.46 8.93h-.13a30.82 30.82 0 0 0-5.62 1.36c-5.8 2.26-23.55 3.92-23.73 3.94l.19 2c.74-.07 18.21-1.7 24.27-4.06a29 29 0 0 1 5.24-1.26l.42-.08a19.59 19.59 0 0 1 .64 5.07 33.16 33.16 0 0 1-.17 3.42c-.68.19-1.35.36-2 .49-4.43.83-15.09 1.8-22.45 2.41L254 267l.84.33c6.85-.6 14.91-1.39 18.71-2.1.45-.09.91-.19 1.36-.3a20.39 20.39 0 0 1-2.61 7.14l.73.07a14.65 14.65 0 0 0 1.5.07 23.69 23.69 0 0 0 2.5-7.91 24.2 24.2 0 0 0 12.41-9.12c.11.35.22.71.3 1.07a15.78 15.78 0 0 1-1 10.94 21.55 21.55 0 0 0 3.1-2.86 18.33 18.33 0 0 0-.12-8.54 22.1 22.1 0 0 0-.92-2.92 18.72 18.72 0 0 0 1.54-4.6c.7-3.68-1.4-11.92-4.82-21.26a24.09 24.09 0 0 1 3.87.34c-.34-.78-.6-1.49-.84-2.16Zm-5.95-.14a32.67 32.67 0 0 0-5.13.84c-1.11-2.26-2.59-5.2-4.26-8.36 1.43-1.46 2.91-2.88 4.42-4.24 1.79 3.9 3.48 7.9 4.97 11.76Zm-10.5 11.74a51.23 51.23 0 0 0-7.91-3c1.27-.77 2.64-1.53 4.09-2.26a1.93 1.93 0 0 1 .12.29 1 1 0 0 1 0-.35l.59-.29.34.49-.55.83.72.45.58-.57c.32-.32.53-.53 0-1.71a46.15 46.15 0 0 1 6.35-2.37c.62 1.27 1.05 2.17 1.23 2.56-.11.51-.81 2.6-5.56 5.93Zm7.22-4.57a10.63 10.63 0 0 1 4.38 11.88c-.06.24-.13.45-.2.67a37.1 37.1 0 0 0-9.38-7c3.29-2.4 4.66-4.28 5.2-5.55Zm-13.89-9.17c-.39-.61-.81-1.24-1.26-1.93a46.16 46.16 0 0 0-2.74-3.72c1.08-3.52 2.23-7.1 3.37-10.55 2 3.19 4.06 6.83 5.93 10.31-1.87 1.94-3.64 3.93-5.3 5.89Zm6.31-4c1.45 2.75 2.74 5.3 3.75 7.35a48.5 48.5 0 0 0-6.41 2.43c-.57-1-1.38-2.28-2.49-4 1.61-1.91 3.34-3.83 5.15-5.77Zm-6.5 7.4c.91 1.43 1.56 2.49 2 3.26a66.7 66.7 0 0 0-8.53 5.19c1.79-2.43 4-5.36 6.53-8.44Zm3.27-30.45a152.46 152.46 0 0 1 8.23 15.4c-1.55 1.37-3.07 2.8-4.54 4.28-2.07-3.83-4.36-7.84-6.59-11.24 1.01-3.03 2-5.89 2.9-8.44ZM260 184.55a48 48 0 0 1 4.58 3.66 32.33 32.33 0 0 1 4.57 5.64c-.9 2.56-1.9 5.42-2.93 8.47a30.88 30.88 0 0 0-4.21-5.06 28.93 28.93 0 0 0-4.37-3.23c.77-3.42 1.58-6.62 2.36-9.48Zm-2.83 11.56a25.2 25.2 0 0 1 3.5 2.63 33.72 33.72 0 0 1 4.75 6c-1.18 3.53-2.38 7.23-3.52 10.9a77.09 77.09 0 0 0-7.15-6.94c.7-4.4 1.53-8.63 2.41-12.59Zm1 32.6a46.88 46.88 0 0 0-5.17-5c.29-4.25.78-8.5 1.4-12.66a68.83 68.83 0 0 1 6.82 6.84c-1.17 3.75-2.22 7.44-3.07 10.82Zm1.53 2.11.12-.09-.07-.09c.81-3.35 1.85-7.06 3-10.9.63.81 1.23 1.64 1.78 2.48s1.11 1.69 1.58 2.43c-2.78 3.37-5.2 6.58-7.09 9.22.17-.97.41-2 .66-3.05Zm.2 7.25c1.14-.88 2.6-1.93 4.29-3l-.06.27a47.83 47.83 0 0 1 8 2.8c-1.5.94-3.3 1.95-5.45 3a31.85 31.85 0 0 0-6.8-3.07Zm8.65 4.36c2.25-1.18 4.13-2.28 5.68-3.3a35.62 35.62 0 0 1 10.43 7.73c-1.81 3.31-5 4.39-8.6 5.11a21.07 21.07 0 0 0-7.53-9.54Zm8.7 19.65c.06-.87.1-1.78.1-2.75a21 21 0 0 0-.69-5.44c3.58-.75 7.15-1.95 9.36-5.38a21.29 21.29 0 0 1 2.51 4.27 21.41 21.41 0 0 1-11.3 9.3Zm13.06-14.2a16 16 0 0 1-.7 2.51 24.77 24.77 0 0 0-2.61-3.89 14.09 14.09 0 0 0 .63-1.93 12.9 12.9 0 0 0-6.2-14.57c-.19-.4-.54-1.16-1-2.16a30.76 30.76 0 0 1 5-.74c3.38 9.17 5.57 17.29 4.86 20.78Z"
          className="animable"
          style={{
            fill: "#ccc",
            transformOrigin: "266.292px 222.785px",
          }}
        />
      </g>
      <path
        d="M254 267s10.8 4.37 19 5.14 20.82-5.14 22.88-15.94-4.89-31.1-7.2-35.47-16.2-35.22-23.91-41.9-20.31-10.55-22.88-11.57-.77 8.74-1.28 14.91-.52 37.53-.52 37.53l-1.8 41.13s9.49 3.58 15.71 6.17Z"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "267.273px 219.696px",
        }}
      />
      <path
        d="M267.06 233.82s12.09-9.26 21.34 3.34"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "277.73px 233.85px",
        }}
      />
      <path
        d="M180.93 98.38c-.52.86-.25-13.86 3.92-21 1.4-2.39 14.2-6.87 26.57-4s17.67 9.06 18.11 11.93-1.53 21.25-1.53 21.25-19.9-11.49-47.07-8.18Z"
        className="animable"
        style={{
          fill: "#1dd21d",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "205.164px 89.5056px",
        }}
      />
      <ellipse
        cx={203.8}
        cy={112.63}
        className="animable"
        rx={17.12}
        ry={42.75}
        style={{
          fill: "#a6a6a6",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "203.8px 112.63px",
          transform: "rotate(-84.13deg)",
        }}
      />
      <path
        d="M156.33 162.33s-16.33 5.34-24 11.67-35.66 32.33-48 41-17 23-10.66 33.67S92.33 262 100.33 260s18-13.67 27-19 16-15 16-15 4.67-33.67 6.34-43.67 8-18.66 8-18.66 0-2.34-1.34-1.34Z"
        className="animable"
        style={{
          fill: "#fff",
          transformOrigin: "114.257px 211.348px",
        }}
      />
      <g
        className="animable"
        style={{
          clipPath: "url(_.html#freepik--clip-path-2--inject-69&quot",
          transformOrigin: "112.31px 212.705px",
        }}
      >
        <path
          d="M140.15 181.11c.5-5.48 1-9.93 1.41-12.75-.72.35-1.44.72-2.15 1.1-.4 3.14-.92 7.65-1.39 13a67.48 67.48 0 0 0-9.07 7.18c-1.5 1.44-3.2 2.9-5 4.36-.24-5.22-.38-9.47-.46-12.27l-2 1.73c.09 3 .24 7.14.48 12-4.3 3.27-9.22 6.56-14.16 9.81-.91-2.92-1.74-5.48-2.43-7.6l-1.64 1.43c.68 2.08 1.47 4.54 2.33 7.32l-1.24.81c-3.81 2.49-7.48 4.9-10.78 7.21a21.73 21.73 0 0 0-3.51-2.44c-.47-.26-.92-.48-1.36-.67-.63.49-1.24 1-1.83 1.41a14.86 14.86 0 0 1 2.35 1.08 19.64 19.64 0 0 1 2.67 1.85c-2.15 1.55-4.11 3.05-5.76 4.48a31.57 31.57 0 0 0-5.35 5.85 22.62 22.62 0 0 0-7.36.56q-.63 1.2-1.14 2.43A21.54 21.54 0 0 1 80 228c-4.74 8.27-4 18 2.27 28.56a1 1 0 0 0 .86.49.94.94 0 0 0 .51-.14 1 1 0 0 0 .35-1.37c-6-10.19-6.58-19.49-1.73-27.33a19.59 19.59 0 0 1 2.39.5 23.26 23.26 0 0 1 8 4.07c-.28.48-.56 1-.8 1.45-5.31 10.57 2.44 17.17 2.52 17.24a1 1 0 0 0 1.41-.13 1 1 0 0 0-.13-1.41c-.07-.06-6.62-5.64-2-14.8.17-.35.38-.7.58-1.06a43.93 43.93 0 0 1 8.14 10 9.49 9.49 0 0 0 .42 4.65 1 1 0 0 0 .9.55 1 1 0 0 0 .45-.1 1 1 0 0 0 .53-1q1.36 2.61 2.66 5.56a1 1 0 0 0 .92.6 1 1 0 0 0 .4-.09 1 1 0 0 0 .51-1.31 80.22 80.22 0 0 0-4.77-9.33 24.51 24.51 0 0 1 1.72-6 151.81 151.81 0 0 1 5.13 16c.57-.44 1.13-.9 1.7-1.37a143.78 143.78 0 0 0-5.67-17.05 34.83 34.83 0 0 1 5-7c1.76 6.72 3.42 13.8 4.74 20.69l1.76-1.46c-1.38-7-3.09-14.15-4.87-20.91.84-.82 1.74-1.63 2.71-2.42a62.58 62.58 0 0 1 6.92-4.8c.27 3.2.57 6.47.91 9.75a43.22 43.22 0 0 0-7.8 5.87 1 1 0 0 0 0 1.41 1 1 0 0 0 1.42 0 38.57 38.57 0 0 1 6.62-5.06c.38 3.58.82 7.17 1.3 10.7.45-.3.91-.59 1.36-.86l.49-.31c-.47-3.53-.89-7.11-1.27-10.68a121.33 121.33 0 0 1 10.8-5.54c.21 2.58.49 5.12.84 7.58.63-.67 1.22-1.32 1.76-1.92-.27-2.13-.5-4.31-.67-6.53 1.7-.75 3.29-1.42 4.66-2 .1-.71.21-1.47.33-2.3-1.46.58-3.21 1.3-5.14 2.14-.21-3.33-.32-6.71-.36-10.09 2.59-1.15 5-2.15 7-3 .1-.76.21-1.52.32-2.3-2.07.82-4.6 1.85-7.37 3.06 0-3.45.07-6.88.2-10.21 3.56-2.16 6.59-3.95 9-5.36.13-.87.26-1.72.38-2.54a810.48 810.48 0 0 0-9.26 5.5c.22-4.59.52-9 .86-12.89a111.35 111.35 0 0 1 11-6.25c.29-.94.61-1.84.95-2.72a116.63 116.63 0 0 0-11.71 6.38ZM122.09 198c.14 2.73.31 5.66.51 8.73-4.4 2.79-8.38 5.44-12 8-.76-2.61-1.5-5.09-2.21-7.38 4.76-3.11 9.48-6.26 13.7-9.35Zm-16.17 11c.26-.16.51-.33.76-.5.72 2.34 1.47 4.85 2.24 7.5a90.57 90.57 0 0 0-8 6.67 39.49 39.49 0 0 0-5.35-6.74c3.16-2.24 6.7-4.56 10.35-6.93Zm-12.23 22a25.11 25.11 0 0 0-8.5-4.3c-.56-.15-1.11-.27-1.65-.38a29.31 29.31 0 0 1 4.38-4.67c1.69-1.46 3.73-3 6-4.62a37.14 37.14 0 0 1 5.55 7 44.08 44.08 0 0 0-5.78 6.97Zm9.17 10.12a43.32 43.32 0 0 0-7.6-8.85 41.22 41.22 0 0 1 5.28-6.47 76.56 76.56 0 0 1 4.54 9.23 29.6 29.6 0 0 0-2.22 6.13Zm3.42-8.31a79.42 79.42 0 0 0-4.28-8.41 88.49 88.49 0 0 1 7.53-6.33c.71 2.49 1.43 5.08 2.14 7.75a37 37 0 0 0-5.39 7.03Zm9.06-10.41c-.72.58-1.39 1.17-2 1.77-.69-2.55-1.38-5-2.07-7.43 3.47-2.55 7.32-5.14 11.52-7.82q.25 3.89.59 8a67.44 67.44 0 0 0-8.04 5.52Zm9.33-14.7 2.31-1.45q5.43-3.37 9.94-6.11c-.11 3.23-.17 6.54-.15 9.87-3.71 1.68-7.7 3.64-11.52 5.8-.25-2.74-.41-5.45-.58-8.07Zm1.66 20.08c-.34-3.29-.63-6.56-.9-9.76 3.71-2.13 7.66-4.1 11.36-5.79 0 3.37.17 6.74.4 10.06-3.46 1.6-7.29 3.47-10.86 5.53Zm10.68-30c-3.29 2-7 4.26-11.08 6.8l-1.41.88c-.2-3.18-.36-6.19-.5-9a81.09 81.09 0 0 0 6.32-5.37 63.6 63.6 0 0 1 7.46-6c-.32 3.91-.6 8.21-.8 12.7Z"
          className="animable"
          style={{
            fill: "#ccc",
            transformOrigin: "112.31px 212.705px",
          }}
        />
      </g>
      <path
        d="M156.33 162.33s-16.33 5.34-24 11.67-35.66 32.33-48 41-17 23-10.66 33.67S92.33 262 100.33 260s18-13.67 27-19 16-15 16-15 4.67-33.67 6.34-43.67 8-18.66 8-18.66 0-2.34-1.34-1.34Z"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "114.257px 211.348px",
        }}
      />
      <path
        d="M82.67 238.67a11.18 11.18 0 0 0-10.79 6.07 20.36 20.36 0 0 0 1.79 3.93 24 24 0 0 0 12.86 10.46c4.87-1.88 8.47-5.37 8.47-8.46 0-4-1.67-11.67-12.33-12Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "83.44px 248.885px",
        }}
      />
      <path
        d="m150 427.23-11.82 11c-3.84 3.57-7.42 6.87-7.42 9.34s-1.37 5.77.55 7.42 10.72 3.58 19.24 3.58a28.68 28.68 0 0 0 18.15-6.87c3.29-2.75 3.57-6.33 7.14-8s9.9-1.37 11-5.49-.55-10.45-.55-10.45Z"
        className="animable"
        style={{
          fill: "#878787",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "158.752px 442.9px",
        }}
      />
      <path
        d="M186.82 438.23a13.32 13.32 0 0 0 .37-3.21c-4.15 3.38-12.84 6.9-15.52 9.27-3.12 2.76-5.88 9.72-21.37 10.56-13 .71-18.43-3.12-19.87-4.4-.25 1.76-.37 3.49.86 4.54 1.93 1.65 10.72 3.58 19.24 3.58a28.68 28.68 0 0 0 18.15-6.87c3.29-2.75 3.57-6.33 7.14-8s9.9-1.35 11-5.47Z"
        className="animable"
        style={{
          fill: "#263238",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "158.729px 446.795px",
        }}
      />
      <path
        d="m238 427.23 11.82 11c3.85 3.57 7.42 6.87 7.42 9.34s1.37 5.77-.55 7.42-10.72 3.58-19.24 3.58a28.65 28.65 0 0 1-18.14-6.87c-3.3-2.75-3.57-6.33-7.15-8s-9.89-1.37-11-5.49.55-10.45.55-10.45Z"
        className="animable"
        style={{
          fill: "#878787",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "229.246px 442.9px",
        }}
      />
      <path
        d="M201.16 438.23a13.32 13.32 0 0 1-.38-3.21c4.16 3.38 12.84 6.9 15.52 9.27 3.13 2.76 5.89 9.72 21.37 10.56 13 .71 18.43-3.12 19.88-4.4.24 1.76.36 3.49-.87 4.54-1.92 1.65-10.72 3.58-19.24 3.58a28.65 28.65 0 0 1-18.14-6.87c-3.3-2.75-3.57-6.33-7.15-8s-9.89-1.35-10.99-5.47Z"
        className="animable"
        style={{
          fill: "#263238",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "229.243px 446.795px",
        }}
      />
      <path
        d="M190.5 153s-25.79 7.18-32.79 9.18S147 179 146 196s-6 77-6.5 79.5-6.19 25.5-4.69 33.5 15.69 104 15.69 104-4 6-3 7.5 1.5 9 1.5 9 12.5 4.5 20.5 4.5 18-3 18-3-2.5-18.5-1.5-29.5 1-83 1-83l10 114s12 3.5 22.5 3S241 429 241 429s1.5-8.5.5-12.5-7-11-7-13.5 5-86 5-86 3-23.5 2.5-35.5.5-40 .5-40 2-25.5 3.5-40 1.92-27.5 1.42-30.5-24.92-13-30.92-15-18.5-2.5-26-3Z"
        className="animable"
        style={{
          fill: "#fff",
          transformOrigin: "191.09px 294.274px",
        }}
      />
      <g
        className="animable"
        style={{
          clipPath: "url(_.html#freepik--clip-path-3--inject-69&quot",
          transformOrigin: "196.14px 203.995px",
        }}
      >
        <path
          d="M245.6 205.49c-1.9-.84-3.85-1.62-5.87-2.34l.71-11.53c1.66.75 4.34 1.81 6 2.66l-.1-2q-2.84-1.49-5.74-2.76l.81-13.09c2 .94 3.9 1.94 5.79 3l.4-.7v-1.34q-3-1.68-6.08-3.12L242 167c-.62-.33-1.26-.66-1.94-1l-.46 7.42c-2.78-1.22-5.61-2.3-8.48-3.26l1.16-7.79-1.89-.83-1.2 8a121.8 121.8 0 0 0-15.66-3.79l1.26-10.18c-.61-.15-1.27-.3-2-.43l-1.27 10.27a158.63 158.63 0 0 0-16.77-1.76l1-10.26-2-.12-1 10.28c-5.45-.22-10.73-.19-15.71 0 .18-2.6.34-4.92.48-6.88l-2.05.57c-.13 1.87-.28 4-.44 6.4-5.35.27-10.33.73-14.78 1.26q.33-1.89.63-3.57l-2.14.6c-.18 1-.37 2.09-.56 3.22-1.79.23-3.47.47-5.05.72a18.63 18.63 0 0 0-1.33 2.13c1.85-.29 3.87-.6 6-.88-.69 4.18-1.39 9-2 14.35-3.27.5-6.09 1-8.39 1.45q-.18 1-.33 2.1c2.26-.45 5.12-1 8.47-1.49-.4 3.42-.78 7.05-1.12 10.87-3.23.16-6 .34-8.36.5 0 .36 0 .71-.07 1.06s0 .63-.06 1c2.29-.17 5.09-.35 8.31-.51a384.36 384.36 0 0 0-.54 58.27l2-.14a382.12 382.12 0 0 1 .57-58.23c4.83-.21 10.46-.36 16.58-.35-1.09 16.77-2.18 34.46-2.74 46.3l2 .1c.56-11.86 1.65-29.59 2.75-46.4 4.65 0 9.56.16 14.6.43L185.61 235l2 .2 3.86-38.62c5.26.31 10.64.78 16 1.44l-3.63 29.21 2 .25 3.63-29.2c5.08.68 10.13 1.54 15 2.63l-5.14 34.5 2 .29 5.13-34.34c3.86.92 7.61 2 11.2 3.21l-2.36 38.21 2 .13 2.33-37.65q3 1.09 5.8 2.37c.04-.76.1-1.46.17-2.14Zm-32.35-37.83a121 121 0 0 1 15.62 3.82l-2 13.06a129.3 129.3 0 0 0-15.34-3.39ZM173 194c-6.09 0-11.7.14-16.54.35.35-3.9.75-7.6 1.16-11.09 4.68-.67 10.17-1.29 16.21-1.67-.29 3.99-.57 8.16-.83 12.41Zm1-14.41c-6 .37-11.42 1-16.09 1.62.67-5.36 1.38-10.16 2.07-14.32 4.48-.54 9.53-1 15-1.3-.37 4.15-.69 8.9-1.04 14ZM243.68 227c-34.19-16.18-81.58-15.35-98.85-14.4q-.08 1-.15 2c17-1 64.83-1.9 98.82 14.51.06-.65.12-1.36.18-2.11Zm-54-32.58c-5.07-.27-10-.4-14.67-.44.28-4.3.56-8.51.83-12.54 4.78-.25 9.87-.35 15.16-.2Zm1.52-15.17c-5.31-.15-10.42-.05-15.22.19.34-5.09.66-9.84.95-14 5-.2 10.22-.24 15.65 0ZM207.71 196c-5.38-.67-10.78-1.14-16.05-1.45l1.34-13.22a156.26 156.26 0 0 1 16.37 1.49Zm-14.53-16.66 1.38-13.79a157.44 157.44 0 0 1 16.72 1.76l-1.68 13.53a160 160 0 0 0-16.42-1.49Zm31.59 19.55c-4.91-1.09-10-2-15.07-2.63l1.63-13.14a124.39 124.39 0 0 1 15.29 3.41Zm13 3.57c-3.55-1.19-7.24-2.23-11-3.12l1.83-12.23a103.75 103.75 0 0 1 9.93 3.64Zm.85-13.82q-4.81-2-9.77-3.53l1.94-13q4.4 1.49 8.65 3.39Z"
          className="animable"
          style={{
            fill: "#ccc",
            transformOrigin: "196.14px 203.995px",
          }}
        />
      </g>
      <path
        d="M190.5 153s-25.79 7.18-32.79 9.18S147 179 146 196s-6 77-6.5 79.5-6.19 25.5-4.69 33.5 15.69 104 15.69 104-4 6-3 7.5 1.5 9 1.5 9 12.5 4.5 20.5 4.5 18-3 18-3-2.5-18.5-1.5-29.5 1-83 1-83l10 114s12 3.5 22.5 3S241 429 241 429s1.5-8.5.5-12.5-7-11-7-13.5 5-86 5-86 3-23.5 2.5-35.5.5-40 .5-40 2-25.5 3.5-40 1.92-27.5 1.42-30.5-24.92-13-30.92-15-18.5-2.5-26-3Z"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "191.09px 294.274px",
        }}
      />
      <path
        d="m192.88 170.11-4.22 40.56"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "190.77px 190.39px",
        }}
      />
      <path
        d="m187 318.5 10 114s12 3.5 22.5 3S241 429 241 429s1.5-8.5.5-12.5-7-11-7-13.5 5-86 5-86 3-23.5 2.5-35.5c-.06-1.33-.09-2.87-.11-4.53-1-3.21-5.6-18-9.21-33.54-4.08-17.57-8.38-34.49-8.38-34.49l-61-5c-2.82-.63-3.13 2.51-3.13 2.51l-18.68 47c-1 12-1.85 21.19-2 22.14C139 278 133.31 301 134.81 309s15.69 104 15.69 104-4 6-3 7.5 1.5 9 1.5 9 12.5 4.5 20.5 4.5 18-3 18-3-2.5-18.5-1.5-29.5 1-83 1-83Z"
        className="animable"
        style={{
          fill: "#1dd21d",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "188.308px 319.703px",
        }}
      />
      <path
        d="M169.63 215.82 211 219.9l-.56 25.7a7.43 7.43 0 0 1-2.79 5.65l-18.22 14.57a5.56 5.56 0 0 1-7.66-.68l-15.44-17.71a7.46 7.46 0 0 1-1.69-6.32Z"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "187.751px 241.43px",
        }}
      />
      <path
        d="M173.08 280.76s11.92 3.76 27.92.62"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "187.04px 281.696px",
        }}
      />
      <path
        d="m183.43 285.46-.31 25.41.7-.61a13.47 13.47 0 0 0 4.58-9.51l.68-14.35"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "186.1px 298.165px",
        }}
      />
      <path
        d="m174.33 314.64 17.88 4.7"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "183.27px 316.99px",
        }}
      />
      <path
        d="M182.7 148.75s-4.64 6.63-4.86 13.26-2.87 15 0 15.46 13-8.62 16.13-7.95 11.7 11.26 13.69 11 5.75-8.61 5.75-18.11-.67-11.49-6-14.58-17.64-6.37-24.71.92Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "194.962px 162.437px",
        }}
      />
      <path
        d="M186.23 152.73s1.55 13.92 6.41 16.34S207 156.26 208.1 155.6s-12.1 1.33-21.87-2.87Z"
        className="animable"
        style={{
          fill: "#ccc",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "197.197px 161.03px",
        }}
      />
      <path
        d="M224.59 130.45s4.06-4.89 6-2-.22 8.39-2.65 11.26a8.45 8.45 0 0 1-5.31 3.1Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "226.985px 135.173px",
        }}
      />
      <path
        d="M178.94 125.56s-4.41-5.31-6-.67 3.76 12.82 4.42 12.82h.66Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "175.793px 130.349px",
        }}
      />
      <path
        d="M180.4 109.64s-3.56 28.91-1.12 36 12 13.79 20.91 13.34 17.13-4.89 20-8 6.67-39.37 6.67-39.37-9.56-5.12-24.69-6.67-21.77 4.7-21.77 4.7Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "202.643px 131.847px",
        }}
      />
      <path
        d="M211.32 124.12a.52.52 0 1 1-.51-.51.51.51 0 0 1 .51.51Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".5px",
          transformOrigin: "210.8px 124.13px",
        }}
      />
      <path
        d="M217.45 123.26a.52.52 0 1 1-.51-.51.51.51 0 0 1 .51.51Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".5px",
          transformOrigin: "216.93px 123.27px",
        }}
      />
      <path
        d="M216.82 126.7a.52.52 0 1 1-1 0 .52.52 0 1 1 1 0Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".5px",
          transformOrigin: "216.32px 126.7px",
        }}
      />
      <path
        d="M191.15 121.31a.52.52 0 1 0 .51-.51.51.51 0 0 0-.51.51Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".5px",
          transformOrigin: "191.67px 121.32px",
        }}
      />
      <path
        d="M185 120.45a.52.52 0 1 0 .51-.51.51.51 0 0 0-.51.51Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".5px",
          transformOrigin: "185.52px 120.46px",
        }}
      />
      <path
        d="M185.65 123.89a.52.52 0 1 0 .51-.51.51.51 0 0 0-.51.51Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".5px",
          transformOrigin: "186.17px 123.9px",
        }}
      />
      <path
        d="M225.42 111.11a14.77 14.77 0 0 0-1.83 8 67.29 67.29 0 0 0 1.6 8.48l-.6 2.83 2.29-18.81Z"
        className="animable"
        style={{
          fill: "#263238",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "225.223px 120.765px",
        }}
      />
      <path
        d="M182.32 108.82a41 41 0 0 1 0 7.79 15.63 15.63 0 0 1-2.75 5.74l-.63 3.21 1.46-15.92Z"
        className="animable"
        style={{
          fill: "#263238",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "180.723px 117.19px",
        }}
      />
      <path
        d="M197.94 117.82s-2.87 10.61-2.43 11.71 4.2 2 7.29 1.55 2.2-13.48 2.2-13.48"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "200.292px 124.399px",
        }}
      />
      <path
        d="M210.53 119.15s3.1-2.21 7.29.66"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "214.175px 119.074px",
        }}
      />
      <path
        d="M187.12 117.16a4.71 4.71 0 0 1 6 .44"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "190.12px 116.942px",
        }}
      />
      <path
        d="M196.4 109s-7.74-.89-11.49 2.43"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 3,
          transformOrigin: "190.655px 110.161px",
        }}
      />
      <path
        d="M209 111.42s7.29-1.77 11.49 4"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 3,
          transformOrigin: "214.745px 113.292px",
        }}
      />
      <path
        d="M222 134.39c-1.54 2.87-5.52 6-5.52 6s.22-8-2.65-8.4-13.26.22-18.34-1.54c0 0-10.16-1.55-10.6.66s-1.55 7.51-1.55 7.51-.88.44-2.43-3.53a42.25 42.25 0 0 1-2.12-8.44c-.5 7.66-.67 15.73.47 19 2.45 7.12 12 13.79 20.91 13.34s17.13-4.89 20-8c1.43-1.54 3.08-11.2 4.38-20.56a29.4 29.4 0 0 0-2.55 3.96Zm-12.59 9.94c-1.74 1-4.85 1.25-8.19 1.06-1.09-3.7-1.54-3.27-4.4-3.27-1.91 0-2.06 1.46-2 2.44a28 28 0 0 1-6-1.77c-4.2-2-.67-7.29-.67-7.29 6.41 2.43 22.09 1.54 22.09 1.54s3.39 4.86-.81 7.29Z"
        className="animable"
        style={{
          fill: "#263238",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "201.477px 142.831px",
        }}
      />
      <path
        d="M160.22 206.41s.94 7.84 2.82 8.16 3.77-8.79 3.77-8.79-5.02.63-6.59.63Z"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "163.515px 210.179px",
        }}
      />
      <path
        d="M217.71 208.4s-.45 7.89 1.35 8.53 5.24-8 5.24-8-5.05-.25-6.59-.53Z"
        className="animable"
        style={{
          fill: "none",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "220.98px 212.682px",
        }}
      />
      <path
        d="M163 159.36s-4 39.52-4 44.23 6.9 7.21 8.79-.63 5.64-45.17 5.64-45.17-6-.63-10.43 1.57Z"
        className="animable"
        style={{
          fill: "#1dd21d",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "166.215px 182.857px",
        }}
      />
      <path
        d="M224.21 158.73s-9.1 48-7.21 50.19 5.64 5.33 9.09-1.25 9.73-45.18 9.73-45.18-6.28-3.49-11.61-3.76Z"
        className="animable"
        style={{
          fill: "#1dd21d",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "226.281px 185.175px",
        }}
      />
      <path
        d="M165.55 211.9a2 2 0 1 1-2-2 2 2 0 0 1 2 2Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "163.55px 211.9px",
        }}
      />
      <path
        d="M221.7 215a2 2 0 1 1-2-2 2 2 0 0 1 2 2Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "219.7px 215px",
        }}
      />
      <path
        d="M262.18 248.22s7.71 2.57 6.17 11.56-7.46 9-9 8.74A55.33 55.33 0 0 1 254 267s3.86-4.88 2.06-10.28-1.59-9.02 6.12-8.5Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "261.277px 258.38px",
        }}
      />
      <path
        d="M223.88 262.1a16.55 16.55 0 0 0 4.88 8.22c3.86 3.35 11.05 3.86 11.05 3.86a23.16 23.16 0 0 1-5.91 8.74c-4.11 3.6-8.74 8.74-10 12.08s1 2.32 2.57.26 3.6-5.4 3.6-5.4-2.06 6.94 0 5.66 3.34-6.69 3.34-6.69 0 6.69 1.54 5.15 1.29-6.43 1.29-7.2 2.82-1.55 4.37-3.09-4.89 0-4.89 0 9.26-6.42 10.8-8.74-2.32-6.43-3.34-7.71-19.3-5.14-19.3-5.14Z"
        className="animable"
        style={{
          fill: "#cfcfcf",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "235.205px 279.632px",
        }}
      />
      <path
        d="M239.81 274.18a23.16 23.16 0 0 1-5.91 8.74c-4.11 3.6-8.74 8.74-10 12.08s1 2.32 2.57.26 3.6-5.4 3.6-5.4-2.06 6.94 0 5.66 3.34-6.69 3.34-6.69 0 6.69 1.54 5.15 1.29-6.43 1.29-7.2 2.82-1.55 4.37-3.09-4.89 0-4.89 0 9.26-6.42 10.8-8.74c.64-1 .34-2.25-.3-3.51-3.95-1.01-6.41 2.74-6.41 2.74Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "235.204px 284.216px",
        }}
      />
      <path
        d="M222.89 252.76a16.61 16.61 0 0 0 4.89 8.22c3.85 3.34 11.05 3.86 11.05 3.86a23.3 23.3 0 0 1-5.91 8.74c-4.11 3.6-8.74 8.74-10 12.08s1 2.32 2.57.26 3.6-5.4 3.6-5.4-2.05 6.94 0 5.66 3.34-6.69 3.34-6.69 0 6.69 1.55 5.14 1.28-6.42 1.28-7.19 2.83-1.55 4.37-3.09-4.88 0-4.88 0 9.25-6.43 10.8-8.74-2.32-6.43-3.35-7.71-19.31-5.14-19.31-5.14Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "234.232px 270.292px",
        }}
      />
      <path
        d="M238.83 264.84a23.3 23.3 0 0 1-5.91 8.74c-4.11 3.6-8.74 8.74-10 12.08s1 2.32 2.57.26 3.6-5.4 3.6-5.4-2.05 6.94 0 5.66 3.34-6.69 3.34-6.69 0 6.69 1.55 5.14 1.28-6.42 1.28-7.19 2.83-1.55 4.37-3.09-4.88 0-4.88 0 9.25-6.43 10.8-8.74c.64-1 .34-2.25-.31-3.51-3.96-1.01-6.41 2.74-6.41 2.74Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "234.229px 274.876px",
        }}
      />
      <path
        d="M224.67 221s-8-6-14 .33-2.67 20.34 1.33 26 23.33 12.34 35 11.34 20.33-13.67 20.33-20.34-5.66-11.33-10-11.66-12.66-1.67-12.66-1.67-16.34-1-20-4Z"
        className="animable"
        style={{
          fill: "#cfcfcf",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "237.362px 238.599px",
        }}
      />
      <path
        d="M255 209.86s1.43-2.67-.1-7.48-4.81-5-4.81-3.72v2s-3.27-3.5-4.15-2.84-.22 4.37-.22 4.37 6.93 1.6 9.28 7.67Z"
        className="animable"
        style={{
          fill: "#263238",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "250.545px 203.799px",
        }}
      />
      <path
        d="M255 209.86s-2.19-6.59-7.84-8.16-11.92 1-14.12 3.46a123.87 123.87 0 0 0-8.15 11.6c-2.2 3.45-13.49 8.79-11.29 10.67s8.15-.94 8.15-.94-4.08 6.27.94 5.33 5.34-3.14 5.34-3.14-1.26 7.85 2.19 6.59 3.14-4.08 3.14-4.08-1.57 7.22 1.88 7.22 4.08-5 4.08-5 .94 6.59 5 5.64 1.88-4.7 1.88-4.7 5 4.39 6 1.88-1.88-7.21-1.88-7.21-3.45-7.53-.32-10.67 9.73-5 9.73-5Z"
        className="animable"
        style={{
          fill: "#878787",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "236.524px 220.181px",
        }}
      />
      <path
        d="M253.07 215.19c.21.19.42.36.63.53a35.74 35.74 0 0 1 6-2.41l-4.7-3.45s-5.38 2.2-1.93 5.33Z"
        className="animable"
        style={{
          fill: "#1dd21d",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "255.808px 212.79px",
        }}
      />
      <path
        d="M249.39 208.39a1.21 1.21 0 1 1-1.2-1.2 1.2 1.2 0 0 1 1.2 1.2Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "248.18px 208.4px",
        }}
      />
      <path
        d="M260.38 253.87s-6.17 2.57-9.77-.26-9-7.19-13.88-7.19-5.4 4.11-3.09 5.65 7.72 5.66 7.72 5.66-7.2.25-11.31-3.09-7-9.25-9.77-9 .25 5.92.25 5.92-4.11-4.63-5.65-2.83 2.83 7.71 4.88 10.8 13.37 7.47 16.46 8.47a16.18 16.18 0 0 0 4.37 1s10.54-1.5 13.41-2 5.66-1.28 6.69-5.4.46-6.96-.31-7.73Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "237.903px 257.316px",
        }}
      />
      <path
        d="M220.53 251.56s3.6 7.71 9.26 10.79"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "225.16px 256.955px",
        }}
      />
      <path
        d="m145 235.75-55.25-2.5L92 260h.28c1.6 6.07 11.92 11.14 24.65 11.73 5.77.27 12.11-.11 17.61-2.21 5.73-2.18 7.79-7.67 8.54-13.32.31-2.27 1.45-20.47 1.92-20.45Z"
        className="animable"
        style={{
          fill: "#878787",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "117.375px 252.528px",
        }}
      />
      <path
        d="M120.62 245.33q-1.87 0-3.78-.09a63.63 63.63 0 0 1-20-3.87c-7.66-3.07-9.13-6.65-9-9.12s1.91-5.89 9.83-8.25a63.88 63.88 0 0 1 20.3-2 63.63 63.63 0 0 1 20 3.87c7.66 3.07 9.13 6.65 9 9.12h0c-.12 2.46-1.91 5.89-9.83 8.25a59.7 59.7 0 0 1-16.52 2.09Zm-6.51-19.41a55.29 55.29 0 0 0-15.36 1.92c-5.06 1.5-6.92 3.41-7 4.6s1.62 3.26 6.51 5.22a59.56 59.56 0 0 0 18.74 3.58 59.75 59.75 0 0 0 19-1.83c5.06-1.5 6.92-3.41 7-4.6h0c.06-1.18-1.62-3.26-6.51-5.22a59.56 59.56 0 0 0-18.76-3.59c-1.22 0-2.43-.08-3.62-.08Z"
        className="animable"
        style={{
          fill: "#878787",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "117.405px 233.606px",
        }}
      />
      <g
        className="animable"
        style={{
          clipPath: "url(_.html#freepik--clip-path-4--inject-69&quot",
          transformOrigin: "117.38px 232.109px",
        }}
      >
        <ellipse
          cx={117.38}
          cy={233.55}
          className="animable"
          rx={9.54}
          ry={27.37}
          style={{
            fill: "#fff",
            stroke: "#263238",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            transformOrigin: "117.38px 233.55px",
            transform: "rotate(-87.34deg)",
          }}
        />
        <path
          d="M120.65 234.44c-3 2.62-7.31 2.59-9.66-.08s-1.83-7 1.15-9.59 11-5.84 13.35-3.17-1.86 10.21-4.84 12.84Z"
          className="animable"
          style={{
            fill: "#fff",
            stroke: "#263238",
            strokeMiterlimit: 10,
            transformOrigin: "117.846px 228.493px",
          }}
        />
        <path
          d="M115 229.7c0 4-2.88 7.19-6.44 7.19s-6.44-3.22-6.44-7.19 2.89-12.12 6.44-12.12 6.44 8.14 6.44 12.12Z"
          className="animable"
          style={{
            fill: "#fff",
            stroke: "#263238",
            strokeMiterlimit: 10,
            transformOrigin: "108.56px 227.235px",
          }}
        />
        <path
          d="M133.85 233.91c0 4-2.89 7.2-6.44 7.2s-6.44-3.23-6.44-7.2 2.88-12.12 6.44-12.12 6.44 8.14 6.44 12.12Z"
          className="animable"
          style={{
            fill: "#fff",
            stroke: "#263238",
            strokeMiterlimit: 10,
            transformOrigin: "127.41px 231.45px",
          }}
        />
        <path
          d="M125.43 239.11c0 4-2.89 7.2-6.44 7.2s-6.44-3.23-6.44-7.2S115.43 227 119 227s6.43 8.13 6.43 12.11Z"
          className="animable"
          style={{
            fill: "#fff",
            stroke: "#263238",
            strokeMiterlimit: 10,
            transformOrigin: "118.99px 236.655px",
          }}
        />
        <path
          d="M105.61 234.65c0 4-2.88 7.2-6.44 7.2s-6.44-3.22-6.44-7.2 2.88-12.12 6.44-12.12 6.44 8.15 6.44 12.12Z"
          className="animable"
          style={{
            fill: "#fff",
            stroke: "#263238",
            strokeMiterlimit: 10,
            transformOrigin: "99.17px 232.19px",
          }}
        />
        <path
          d="M141.28 234.65c0 4-2.89 7.2-6.44 7.2s-6.44-3.22-6.44-7.2 2.88-12.12 6.44-12.12 6.44 8.15 6.44 12.12Z"
          className="animable"
          style={{
            fill: "#fff",
            stroke: "#263238",
            strokeMiterlimit: 10,
            transformOrigin: "134.84px 232.19px",
          }}
        />
        <path
          d="M112.23 242.86c-3 2.63-7.31 2.59-9.66-.08s-1.84-7 1.15-9.59 11-5.84 13.35-3.17-1.86 10.21-4.84 12.84Z"
          className="animable"
          style={{
            fill: "#fff",
            stroke: "#263238",
            strokeMiterlimit: 10,
            transformOrigin: "109.425px 236.915px",
          }}
        />
        <path
          d="M136.79 235.33c2.76 2.86 2.92 7.19.36 9.65s-6.88 2.15-9.63-.71-6.34-10.73-3.77-13.2 10.25 1.4 13.04 4.26Z"
          className="animable"
          style={{
            fill: "#fff",
            stroke: "#263238",
            strokeMiterlimit: 10,
            transformOrigin: "130.918px 238.46px",
          }}
        />
      </g>
      <path
        d="M144.51 235.93a2 2 0 0 1-2-1.82l-1.11-19.79a22.13 22.13 0 0 0-11.48-17.51l-2.17-1.18a22.2 22.2 0 0 0-32.55 15.94l-3.24 20a2 2 0 0 1-3.94-.64l3.24-20a26.2 26.2 0 0 1 38.41-18.82l2.17 1.19A26.16 26.16 0 0 1 145.4 214l1.1 19.79a2 2 0 0 1-1.81 2.17Z"
        className="animable"
        style={{
          fill: "#878787",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "117.259px 212.435px",
        }}
      />
      <path
        d="M99 272.67s.87.13 5.87.8 13-2.16 14.13-6.14c.59-2-3.67-2-6.67-.66s-13.33 6-13.33 6Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "109.028px 269.652px",
        }}
      />
      <path
        d="M87.67 247s5.66-2.33 11 .67a53.74 53.74 0 0 1 10 7.66s1.66 2-1.67 4-4 .67-6.67-1.33a14.07 14.07 0 0 0-6.33-2.33s6.67 6.33 9 8.33 9-1.67 11 1 1 3.67-4.67 5.33-11 4.67-15.66 1.67-15.67-15.33-17-19.33 6.33-8.34 11-5.67Z"
        className="animable"
        style={{
          fill: "#fff",
          stroke: "#263238",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          transformOrigin: "95.7313px 259.707px",
        }}
      />
    </g>
  </svg>
);
export default AgricultureSvg;
